module.exports = __webpack_public_path__ + "img/result-empty.d426c09f.png";